import { sprintf } from 'sprintf-js';

import type { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { Text } from 'components/Text/Text';
import { ClientOnly } from 'containers/ClientOnly';
import { useI18n } from 'i18n/hooks/useI18n';
import { distanceInWordsToNow } from 'utils/date';

type Props = {
  listingFirstPublished: ApiISODateTimeString;
  isNew: boolean;
};

export function ListingViewHeaderPublishedTag({
  listingFirstPublished,
  isNew,
}: Props) {
  const { i18n } = useI18n();

  return (
    <>
      {isNew && (
        <div>
          <Text
            fontWeight="semiBold"
            color="mediumContentGrey"
            borderBottom="4px solid"
            borderColor="brandYellow"
            display="inline-block"
            lineHeight="6px"
            ml="0px"
            mr="12px"
            p="0px"
          >
            {i18n('New')}
          </Text>
        </div>
      )}

      <Text display="inline-block" color="lightContentGrey">
        <ClientOnly>
          {
            /* TRANSLATORS: Listing page - time published */
            sprintf(getText('Published %(timeAgo)s'), {
              timeAgo: distanceInWordsToNow(listingFirstPublished),
            })
          }
        </ClientOnly>
      </Text>
    </>
  );
}
